// CON-9505. A server-side change to the session made while the Payment Element is mounted has to run
// through the element's own runServerUpdate, or the mounted SDK keeps confirming against the totals it
// cached at init. runServerUpdate lives on the checkout instance, which only exists inside the provider
// tree — this ref is how code outside it (the promo and quantity handlers) reaches the mounted one.
//
// Null whenever no element is up, in which case a plain request is fine: the next init reads current
// session state from Stripe.
let activeCheckout = null

export const setActiveCheckout = (checkout) => {
    activeCheckout = checkout
}

// Guarded so an unmount ordered after a replacement has mounted cannot clear the replacement.
export const clearActiveCheckout = (checkout) => {
    if (activeCheckout === checkout) {
        activeCheckout = null
    }
}

export const getActiveCheckout = () => activeCheckout

// Stripe paints its own field errors only on validateElements() or confirm(), so submit asks first rather
// than opening the processing modal on a blank field. Fails open: confirm() still validates.
export const validateActiveCheckoutElements = async () => {
    const checkout = activeCheckout

    if (!checkout) {
        return true
    }

    try {
        const result = await checkout.validateElements()
        return result?.type !== 'error'
    } catch (error) {
        return true
    }
}
